var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduce",class:{m_introduce:_vm.$store.state.screenType}},[_c('TitleH',[_c('transition',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v(_vm._s(_vm.$t('Nav[0].menuList[0]').toUpperCase()))])])],1),_c('div',{staticClass:"introduce_text ql-editor",domProps:{"innerHTML":_vm._s(_vm.list)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }